import React from 'react';

import { ButtonLink } from 'src/components/Button/ButtonLink';
import { Button } from 'src/components/Button/Button';

import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import classes from './PageBuilderButtonItem.module.scss';
import type { ButtonItemType } from './buttonItemConfigAggregator';

type PageBuilderButtonItemProps = ButtonItemType;

/**
 * Return the PB Button Item
 * @param props
 * @constructor
 */
export function PageBuilderButtonItem(props: PageBuilderButtonItemProps) {
    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderButtonItemProps>(props);

    const buttonClassNames = [classes['root'], 'pageBuilderButtonItemGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        buttonClassNames.push(...props.cssClasses);
    }

    // Parse the button text and background colours from the props
    const buttonTextColour = props.buttonTextColour ? JSON.parse(props.buttonTextColour) : undefined;

    const buttonBackgroundColour = props.buttonBackgroundColour ? JSON.parse(props.buttonBackgroundColour) : undefined;

    /**
     * Render the Button Item UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            classNames={buttonClassNames}
        >
            {!props.linkType && (
                <Button
                    style={{
                        ...advancedSettings,
                        backgroundColor: buttonBackgroundColour,
                        color: buttonTextColour,
                    }}
                    variant={props.buttonType}
                    target={props.openInNewTab ? '_blank' : ''}
                >
                    {props.buttonText}
                </Button>
            )}

            {props.linkType && (
                <ButtonLink
                    style={{
                        ...advancedSettings,
                        backgroundColor: buttonBackgroundColour,
                        color: buttonTextColour,
                    }}
                    to={props.link ?? '/'}
                    variant={props.buttonType}
                    target={props.openInNewTab ? '_blank' : ''}
                >
                    {props.buttonText}
                </ButtonLink>
            )}
        </PageBuilderElementWrapper>
    );
}
